import {ACTION_CODE} from './_actionCode';
import {DealOriginsService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'UPDATE_DEALORIGIN';

export async function updateDealOrigin(
    userData: Record<string, any>,
    dealOriginId: number,
    payloadUpdate: Record<string, any>
) {
    try {
        LoggerService.logInfo('Action - updateDealOriginById - Start');

        const updateDealOriginByIdResult =
            await DealOriginsService.updateDealOrigin(userData, dealOriginId, payloadUpdate);

        LoggerService.logInfo('Action - updateDealOriginById - End - Success');

        return ResultModel.newSuccessResult(updateDealOriginByIdResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - updateDealOriginById - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Erreur de mise à jour d\'une banque',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
